// extracted by mini-css-extract-plugin
export default {"promoGrid":"_k623f0","promoCarousel":"_wh015y"};